export const TYPE_AUCTION_WIN = 'AUCTION_WIN';

export const TYPE_LIST = [
  TYPE_AUCTION_WIN,
];